export default __webpack_public_path__ + "menu-apps-icon.d2fe4c9a176b293025e528bd3878951a.svg";